<script setup>
import { defineProps, defineEmits, onMounted, onUnmounted, watch } from 'vue';
import HeaderIcon from './HeaderIcon.vue';

const props = defineProps({
    isOpen: {
        type: Boolean,
        default: false,
    },
    title: {
        type: String,
        default: '',
    },
});

const emit = defineEmits(['close']);

const handleClose = () => {
    emit('close');
};

</script>

<template>
    <transition name="modal-fade">
        <div v-if="isOpen" class="mobile-menu-modal">
            <div class="mobile-menu-modal__overlay" @click="handleClose"></div>

            <div class="mobile-menu-modal__content">
                <div class="mobile-menu-modal__header">
                    <header-icon name="arrow-left" />

                    <h3 v-if="title" class="mobile-menu-modal__title">
                        {{ title }}
                    </h3>

                    <button
                        class="mobile-menu-modal__close"
                        @click="handleClose"
                    >
                        <header-icon name="close" />
                    </button>
                </div>

                <div class="mobile-menu-modal__body">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>
